import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './../media/img/coco-head-logo.png'
import twitter from './../media/img/twitter.png'
import telegram from './../media/img/telegram.png'
import cancel_icon from './../media/icons/close.png'
import nav_icon from './../media/icons/menu.png'


const NavBar = () => {

    const windowscrollvalue = window.scrollY
    const [showmobilenav, setshowmobilenav] = useState(null)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            console.log(window.innerWidth)
        };

        const handleScroll = () => {
            // console.log(window.scrollY)
            setshowmobilenav(null)
        }

        window.addEventListener('resize', handleResize);

        window.addEventListener('scroll', handleScroll);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll)
        };
    }, []);

    const handleMobilenav = () => {
        if(!showmobilenav) {
            setshowmobilenav(true)
        } else {
            setshowmobilenav(false)
        }
    }

    const [textca, setTextca] = useState("0x52300702c0fcd741c9c75fd65d35add8b618fece0547145b19f7aa59070686a9::suijerry::SUIJERRY");

    const copyToClipboard = () => {
        navigator.clipboard
        .writeText(textca)
        .then(() => {
            alert("ca copied to clipboard!");
        })
        .catch((err) => {
            console.error("Failed to copy ca: ", err);
        });
    };



    return ( 
        <>
            <header>
                <div className="header-inner">
                    <a href="" className='logo'>
                        {/* <img src={logo} className='logo' alt="" /> */}
                        SUI JERRY
                    </a>

                    
                    <p className="the-ca cursor-pointer" onClick={copyToClipboard}>
                        {windowWidth < 700 ? '0x52...6a9::suijerry::SUIJERRY' : '0x52...6a9::suijerry::SUIJERRY'}
                    </p>
                    

                    <div className='flex row gap-15 header-icon-row'>
                        <a href='https://t.me/SuiJerryPortal' target='_blank'>
                            <img src={telegram} alt="" />
                        </a>
                        <a href='https://x.com/suiandjerry' target='_blank'>
                            <img src={twitter} alt="" />
                        </a>
                    </div>

                </div>
            </header>
        </>
    );
}
 
export default NavBar;